import React from 'react';

const moe = () => {
  return (
    <div>
      moe
    </div>
  );
}

export default moe;
